import { cn } from '@repo/ui/lib/utils';
import { Img } from 'openimg/react';
import SectionChild from '~/components/SectionChild';


type Highlight = {
  image: string;
  title: string;
  description: string;
  alt?: string;
};

const highlights: Highlight[] = [
  {
    image: "/image/tuyen-dung/bg-1.jpg",
    title: "Đào tạo kỹ năng môi giới số hóa và bất động sản xanh miễn phí",
    description:
      "Bạn được tham gia các chương trình đào tạo định kỳ với chuyên gia giàu kinh nghiệm. Kiến thức cập nhật giúp nâng cao kỹ năng bán hàng, hiểu sâu sản phẩm và nhanh chóng thích nghi với xu hướng thị trường.",
    alt: "Lớp đào tạo môi giới KLand",
  },
  {
    image: "/image/tuyen-dung/bg-2.jpg",
    title: "Thu nhập cạnh tranh, hoa hồng hấp dẫn",
    description:
      "Chính sách hoa hồng minh bạch, không giới hạn giúp bạn linh hoạt xây dựng kế hoạch thu nhập. KLand luôn ghi nhận nỗ lực bằng các mức thưởng xứng đáng cùng cơ hội thăng tiến rõ ràng.",
    alt: "Đội ngũ môi giới vui mừng",
  },
];

export default function RecruitmentHighlights() {

  return (
    <div className="bg-[#F5F9F9]">
      <SectionChild className="pt-[100px] pb-[100px]">
        <div className="grid gap-8 md:grid-cols-2">
          {highlights.map((item, idx) => (
            <div key={item.title} className={"flex flex-col gap-6 h-full"}>
              <div className={cn("grow", idx === 0 && "order-last")}>
                <div
                  className={cn(
                    "overflow-hidden rounded-3xl max-w-[550px] md:h-[312px] "
                  )}
                >
                  <Img
                    src={item.image}
                    alt={item.alt || item.title}
                    width={550}
                    height={312}
                    fit="cover"
                    className="object-cover w-full h-60 md:h-full"
                  />
                </div>
              </div>

              <div className="flex flex-col">
                <h3 className="text-xl font-semibold text-primary font-helve">
                  {item.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-gray-600">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </SectionChild>
    </div>
  );
}
